<template>
  <div
    id="search-document-dialog"
    :class="[$style.dialog, $style.default]"
  >
    <div :class="$style.title">
      Поиск документов
    </div>
  </div>
</template>

<style module lang="scss">
@import "../commonDialog";

.dialog {
  position: relative;
  overflow: hidden;
}
</style>
